import store from '../../../../store/store';
import { toast } from '../../../../utils/notification';
import { setEventSourceHeartBeat } from '../heartbeat';
import { run as runActions } from '../../../../store/workspaces/workspaces/run';

export const reloadWidget = (event: MessageEvent) => {
  try {
    const { instances } = store.getState().workspaces;
    const data = JSON.parse(event.data);

    const instance = instances?.find(instance =>
      instance.isActive &&
      instance.widgets?.widgets?.some(widget => String(widget.key) === String(data.key))
    );

    if (instance) {
      return runActions(instance.data.key, instance.data.id, {});
    }

  } catch (error: any) {
    toast.error('heartbeat (updateWidgetData)', error.message);
    setTimeout(setEventSourceHeartBeat, 5000);
  }
};
